export default { 
  CertificateFile: require('./CertificateFile').default,
  CertificateList: require('./CertificateList').default,
  CertificateListB2B: require('./CertificateListB2B').default,
  CertificateListFisik: require('./CertificateListFisik').default,
  CertificateSendList: require('./CertificateSendList').default,
  TemplateCertificate: require('./TemplateCertificate').default,
  TemplateCertificateCetak: require('./TemplateCertificateCetak').default,
}